import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
    SofyAuth: "67935C5B-A009-4DC8-9EC6-2F8E9D58E6DC",
  }),
};
// Environment 
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})

export class ReportsService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  addLogs(
    errorType: string,
    errorCategory: string,
    errorDescription: string,
    createdAt: string,
    errorBody: any,
  ): any {
    const data = {
      errorType,
      errorCategory,
      errorDescription,
      createdAt,
      errorBody,
    };
    const URL = `/reports-microservice/error-report`;
    return this.httpClient.post(environment.baseUrl + `${URL}`, data, httpOptions);
  }
}


